module.exports = __webpack_public_path__ + "media/投资统计类项目遥感监管.01bc9a47.mp4";